import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { cleanObjectEmptyFields, createQueryKey } from '@hero/utils';

import { services } from '../../services';

export const useGetRecognitions = (params = {}, options = {}) => {
  const cacheKey = createQueryKey(QUERY_KEYS.useGetRecognitionsKey, params);

  return useQuery(cacheKey, () => services.list(cleanObjectEmptyFields(params)), options);
};
